import Vue from "vue";
import VueRouter from "vue-router";
import PomodoroActiveSession from "../views/pomodoro/PomodoroActiveSession";
import PomodoroReview from "../views/pomodoro/PomodoroReview";
import TrainingWorkout from "../views/training/TrainingWorkout";
import TrainingHistory from "../views/training/TrainingHistory";
import TrainingWeight from "../views/training/TrainingWeight";
import MoodDiary from "../views/mood/MoodDiary.vue";
import MoodReports from "../views/mood/MoodReports";
import SignIn from "../views/auth/SignIn";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    redirect: { name: "pomodoro-active-session" },
  },
  {
    path: "/auth/sign-in",
    name: "sign-in",
    component: SignIn,
    beforeEnter: (to, from, next) => {
      if (localStorage.getItem("authToken")) {
        next("/");
      } else {
        next();
      }
    },
  },
  {
    path: "/pomodoro/active-session",
    name: "pomodoro-active-session",
    component: PomodoroActiveSession,
  },
  {
    path: "/pomodoro/review",
    name: "pomodoro-review",
    component: PomodoroReview,
  },
  {
    path: "/training/workout",
    name: "training-workout",
    component: TrainingWorkout,
  },
  {
    path: "/training/history",
    name: "training-history",
    component: TrainingHistory,
  },
  {
    path: "/training/weight",
    name: "training-weight",
    component: TrainingWeight,
  },
  {
    path: "/mood/diary",
    name: "mood-diary",
    component: MoodDiary,
  },
  {
    path: "/mood/reports",
    name: "mood-reports",
    component: MoodReports,
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  if (!localStorage.getItem("authToken") && to.name != "sign-in") {
    next({ name: "sign-in" });
  } else {
    next();
  }
});

export default router;
